if (!customElements.get('complementary-add-all')) {
  customElements.define(
    'complementary-add-all',
    class ComplementaryAddAll extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-complementary-add-all]');
        if (!this.button) return;
        this.button.addEventListener('click', this.onClick.bind(this));
      }

      onClick() {
        if (this.button.getAttribute('aria-disabled') === 'true') return;

        let items = [];
        try {
          items = JSON.parse(this.dataset.items || '[]');
        } catch (error) {
          items = [];
        }
        if (!items.length) return;

        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const body = { items };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          cart.setActiveElement?.(document.activeElement);
        }
        config.body = JSON.stringify(body);

        const cartAddUrl =
          (typeof routes !== 'undefined' && routes.cart_add_url) || window.routes?.cart_add_url || '/cart/add';

        fetch(cartAddUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'complementary-add-all',
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              return;
            }

            if (!cart) {
              window.location = window.routes?.cart_url || '/cart';
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'complementary-add-all',
                cartData: response,
              });
            }

            if (typeof cart.renderContents === 'function') {
              cart.renderContents(response);
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.button.classList.remove('loading');
            this.button.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}
